export default "__VITE_ASSET__DmibLwmp__"